/* eslint-disable react/no-multi-comp, react/prop-types */
import React from 'react';
import numeral from 'numeral';
import { Field } from 'redux-form';
import _ from 'lodash';

// Components
import { TextInput, IntegerInput, MoneyInput } from 'components/forms/form-elements';
import { RemoveButton } from 'components/widgets/buttons';
import Tooltip from 'components/widgets/overlays/tooltip';


export default function LineItemRows({ fields, disableLineItems, lineItems, change }) {
  return (
    <tbody>
      {fields.map((name, index) => {
        const lineItem = lineItems[index] || {};

        if (lineItem.status === 'Archived') return null;

        return (
          <LineItemRow
            key={index}
            name={name}
            disableLineItems={disableLineItems}
            total={(lineItem.quantity * lineItem.unitCost) || 0}
            // Set the line item status to Archived if it has an id, otherwise remove it entirely
            removeLineItem={() => {
              if (lineItem.id) {
                return change(`lineItems[${index}].status`, 'Archived');
              }
              fields.remove(index);
            }}
            // Only allow removing line items if there are two or more active line items
            disableRemove={_.reject(lineItems, (item) => item.status === 'Archived').length === 1}
          />
        );
      })}
    </tbody>
  );
}


// Internal component
function LineItemRow({ name, total, removeLineItem, disableLineItems, disableRemove }) {
  return (
    <tr className="line-item-row">
      <td />
      <td>
        <Tooltip title={disableLineItems ? 'Can\'t edit line item quantity after a charge has been added' : ''}>
          <Field component={IntegerInput} name={`${name}.quantity`} addonLeft="Qty" disabled={disableLineItems} />
        </Tooltip>
      </td>
      <td>
        <Tooltip title={disableLineItems ? 'Can\'t edit line item unit cost after a charge has been added' : ''}>
          <Field component={MoneyInput} name={`${name}.unitCost`} disabled={disableLineItems} />
        </Tooltip>
      </td>
      <td className="right-align">
        {numeral(total).format('$0,0.00')}
      </td>
      <td className="large-padding-left">
        <Field component={TextInput} name={`${name}.description`} placeholder="Description" />
      </td>
      <td>
        <Tooltip title={disableLineItems ? 'Can\'t remove line items after a charge has been added' : ''}>
          <RemoveButton onClick={removeLineItem} disabled={disableRemove || disableLineItems} />
        </Tooltip>
      </td>
    </tr>
  );
}



// WEBPACK FOOTER //
// ./app/components/models/purchases/forms/components/purchase-order-line-item-rows.js